/**
 * Bağlantıyı (vitrin önizlemesi) yeni sekmede açar; açılan sayfa panele `window.opener` ile erişemez.
 * `window.open(url, '_blank', 'noopener')` tarayıcıda her zaman `null` döndüğü için sekme açılsa da "engellendi"
 * sanılıyordu: sekme önce açılır, sonra bağ kesilir. Tarayıcı açılır pencereyi engellediyse `false` döner.
 */
export function openInNewTab(url: string): boolean {
  const w = window.open(url, '_blank');
  if (!w) return false;
  try {
    w.opener = null;
  } catch {
    // Bazı tarayıcılarda salt okunur; sekme yine açıktır.
  }
  return true;
}
